/**
 * @generated SignedSource<<d73a88203962094704ac116f68350bff>>
 * @relayHash e5c1debce25f6a5681a8faa6f5393318
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5c1debce25f6a5681a8faa6f5393318

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DataCentersHubQuery$variables = {
  arizonaNodeId: string;
  loudounNodeId: string;
  nodeId: string;
  utahNodeId: string;
};
export type DataCentersHubQuery$data = {
  readonly arizona: {
    readonly " $fragmentSpreads": FragmentRefs<"ArizonaSlideMeta_feedContentResource">;
  } | null;
  readonly loudoun: {
    readonly " $fragmentSpreads": FragmentRefs<"LoudounSlideMeta_feedContentResource">;
  } | null;
  readonly node: {
    readonly authors?: ReadonlyArray<{
      readonly name: string;
    }>;
    readonly blocks?: ReadonlyArray<{
      readonly __typename: "CoreHeadingBlockType";
      readonly contents: {
        readonly html: string;
      };
      readonly headingId: string;
      readonly level: number;
    } | {
      readonly __typename: "CoreParagraphBlockType";
      readonly dropcap: boolean;
      readonly paragraphContents: ReadonlyArray<{
        readonly html: string;
      }>;
    } | {
      readonly __typename: "CorePullquoteBlockType";
      readonly citation: {
        readonly html: string;
      };
      readonly contents: {
        readonly html: string;
      };
    } | {
      readonly __typename: "CoreSeparatorBlockType";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"CskNavCommentCount_feedContentResource" | "MetadataContainer_feedContentResource">;
  };
  readonly utah: {
    readonly " $fragmentSpreads": FragmentRefs<"UtahSlideMeta_feedContentResource">;
  } | null;
};
export type DataCentersHubQuery = {
  response: DataCentersHubQuery$data;
  variables: DataCentersHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "arizonaNodeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "loudounNodeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utahNodeId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "html",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "paragraphContents",
  "plural": true,
  "selections": (v7/*:: as any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropcap",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "contents",
  "plural": false,
  "selections": (v7/*:: as any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headingId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "citation",
  "plural": false,
  "selections": (v7/*:: as any*/),
  "storageKey": null
},
v14 = [
  (v6/*:: as any*/)
],
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "loudounNodeId"
  }
],
v16 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "utahNodeId"
  }
],
v17 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "arizonaNodeId"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorProfileResourceType",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v5/*:: as any*/),
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v22 = [
  (v20/*:: as any*/),
  (v18/*:: as any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "retailer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "salePrice",
    "storageKey": null
  },
  (v23/*:: as any*/)
],
v25 = [
  (v23/*:: as any*/)
],
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ThumbnailMapType",
    "kind": "LinkedField",
    "name": "thumbnails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThumbnailType",
        "kind": "LinkedField",
        "name": "horizontal",
        "plural": false,
        "selections": (v25/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v18/*:: as any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageResourceType",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v26/*:: as any*/),
  "storageKey": null
},
v28 = [
  (v20/*:: as any*/),
  (v21/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showScores",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductBrandResourceType",
    "kind": "LinkedField",
    "name": "brand",
    "plural": false,
    "selections": (v22/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductRetailLinkType",
    "kind": "LinkedField",
    "name": "retailLinks",
    "plural": true,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  (v27/*:: as any*/)
],
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductBlockProductType",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": (v28/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "ProductBlockType",
  "abstractKey": null
},
v30 = [
  (v20/*:: as any*/),
  (v21/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "brand",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LegacyProductBlockRetailLinkType",
    "kind": "LinkedField",
    "name": "retailLinks",
    "plural": true,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  (v27/*:: as any*/)
],
v31 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plaintext",
    "storageKey": null
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v33 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RichTextType",
    "kind": "LinkedField",
    "name": "caption",
    "plural": false,
    "selections": (v31/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VolumeVideoResourceType",
    "kind": "LinkedField",
    "name": "video",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "volumeUuid",
        "storageKey": null
      },
      (v20/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "player",
        "storageKey": null
      },
      (v32/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ImageResourceType",
        "kind": "LinkedField",
        "name": "poster",
        "plural": false,
        "selections": (v26/*:: as any*/),
        "storageKey": null
      },
      (v18/*:: as any*/)
    ],
    "storageKey": null
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentsType",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permalink",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "CategoryResourceType",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v20/*:: as any*/),
    (v36/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryResourceType",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v20/*:: as any*/),
        (v36/*:: as any*/),
        (v18/*:: as any*/)
      ],
      "storageKey": null
    },
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v38 = [
  (v35/*:: as any*/),
  (v18/*:: as any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ShareableDataType",
  "kind": "LinkedField",
  "name": "seo",
  "plural": false,
  "selections": [
    (v39/*:: as any*/),
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "RichTextType",
  "kind": "LinkedField",
  "name": "dek",
  "plural": false,
  "selections": (v31/*:: as any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalPublishedAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPaywallEligible",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthorProfileResourceType",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v5/*:: as any*/),
    (v36/*:: as any*/),
    (v20/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageResourceType",
      "kind": "LinkedField",
      "name": "profileImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ThumbnailMapType",
          "kind": "LinkedField",
          "name": "thumbnails",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ThumbnailType",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": (v25/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v18/*:: as any*/)
      ],
      "storageKey": null
    },
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v47 = [
  (v20/*:: as any*/),
  (v36/*:: as any*/),
  (v37/*:: as any*/),
  (v18/*:: as any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalWidth",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalHeight",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesType",
  "kind": "LinkedField",
  "name": "cropCoordinates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = [
  (v23/*:: as any*/),
  (v50/*:: as any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "ledeMedia",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageResourceType",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ThumbnailMapType",
              "kind": "LinkedField",
              "name": "thumbnails",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "social",
                  "plural": false,
                  "selections": (v51/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "horizontal",
                  "plural": false,
                  "selections": (v51/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ThumbnailType",
                  "kind": "LinkedField",
                  "name": "square",
                  "plural": false,
                  "selections": (v51/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v18/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "LedeMediaImageType",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v33/*:: as any*/),
      "type": "LedeMediaVideoType",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourceType",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chorusId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chorusUuid",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wpId",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alt",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "normalizedRatio",
  "storageKey": null
},
v61 = [
  (v20/*:: as any*/),
  (v58/*:: as any*/),
  (v49/*:: as any*/),
  (v48/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ThumbnailMapType",
    "kind": "LinkedField",
    "name": "thumbnails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ThumbnailType",
        "kind": "LinkedField",
        "name": "social",
        "plural": false,
        "selections": [
          (v23/*:: as any*/),
          (v59/*:: as any*/),
          (v60/*:: as any*/),
          (v50/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v18/*:: as any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageResourceType",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v61/*:: as any*/),
  "storageKey": null
},
v63 = [
  (v62/*:: as any*/)
],
v64 = [
  (v18/*:: as any*/),
  (v54/*:: as any*/)
],
v65 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHub",
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "template",
      "storageKey": null
    }
  ],
  "type": "PostResourceType",
  "abstractKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streamPublishedAt",
  "storageKey": null
},
v69 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CoreImageBlockType",
    "kind": "LinkedField",
    "name": "images",
    "plural": true,
    "selections": (v63/*:: as any*/),
    "storageKey": null
  }
],
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "quickAttachment",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        (v29/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "QuickPostResourceType",
  "abstractKey": null
},
v71 = [
  (v6/*:: as any*/),
  (v18/*:: as any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v19/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalBylines",
        "storageKey": null
      },
      (v42/*:: as any*/),
      (v20/*:: as any*/),
      (v56/*:: as any*/),
      (v54/*:: as any*/),
      (v55/*:: as any*/),
      (v53/*:: as any*/),
      (v36/*:: as any*/),
      (v34/*:: as any*/)
    ],
    "type": "FeedContentResourceInterface",
    "abstractKey": "__isFeedContentResourceInterface"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DataCentersHubQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*:: as any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuthorProfileResourceType",
                  "kind": "LinkedField",
                  "name": "authors",
                  "plural": true,
                  "selections": [
                    (v5/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "blocks",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v6/*:: as any*/),
                        (v8/*:: as any*/),
                        (v9/*:: as any*/)
                      ],
                      "type": "CoreParagraphBlockType",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v6/*:: as any*/),
                        (v10/*:: as any*/),
                        (v11/*:: as any*/),
                        (v12/*:: as any*/)
                      ],
                      "type": "CoreHeadingBlockType",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v6/*:: as any*/),
                        (v10/*:: as any*/),
                        (v13/*:: as any*/)
                      ],
                      "type": "CorePullquoteBlockType",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v14/*:: as any*/),
                      "type": "CoreSeparatorBlockType",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MetadataContainer_feedContentResource"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CskNavCommentCount_feedContentResource"
                }
              ],
              "type": "FeedContentResourceInterface",
              "abstractKey": "__isFeedContentResourceInterface"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": "loudoun",
        "args": (v15/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LoudounSlideMeta_feedContentResource"
              }
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "utah",
        "args": (v16/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UtahSlideMeta_feedContentResource"
              }
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "arizona",
        "args": (v17/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArizonaSlideMeta_feedContentResource"
              }
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DataCentersHubQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v18/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v19/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "blocks",
                "plural": true,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*:: as any*/),
                      (v9/*:: as any*/)
                    ],
                    "type": "CoreParagraphBlockType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/)
                    ],
                    "type": "CoreHeadingBlockType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*:: as any*/),
                      (v13/*:: as any*/)
                    ],
                    "type": "CorePullquoteBlockType",
                    "abstractKey": null
                  },
                  (v29/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegacyProductBlockProductType",
                        "kind": "LinkedField",
                        "name": "legacyProduct",
                        "plural": false,
                        "selections": (v30/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "LegacyProductBlockType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductBlockProductType",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": true,
                        "selections": (v28/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ProductsTableBlockType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegacyProductBlockProductType",
                        "kind": "LinkedField",
                        "name": "legacyProducts",
                        "plural": true,
                        "selections": (v30/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "LegacyProductsTableBlockType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v33/*:: as any*/),
                    "type": "VideoBlockType",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v20/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": null
                  },
                  (v35/*:: as any*/),
                  (v18/*:: as any*/),
                  (v36/*:: as any*/),
                  (v37/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InternalCategoryResourceType",
                "kind": "LinkedField",
                "name": "internalCategories",
                "plural": true,
                "selections": (v38/*:: as any*/),
                "storageKey": null
              },
              (v20/*:: as any*/),
              (v41/*:: as any*/),
              (v42/*:: as any*/),
              (v43/*:: as any*/),
              (v32/*:: as any*/),
              (v36/*:: as any*/),
              (v44/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LiveStatusType",
                "kind": "LinkedField",
                "name": "liveStatus",
                "plural": false,
                "selections": [
                  (v45/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v46/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "seoArticleBody",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CampaignResourceType",
                "kind": "LinkedField",
                "name": "primaryCampaign",
                "plural": false,
                "selections": [
                  (v18/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryResourceType",
                "kind": "LinkedField",
                "name": "primaryCategory",
                "plural": false,
                "selections": (v47/*:: as any*/),
                "storageKey": null
              },
              (v52/*:: as any*/),
              (v53/*:: as any*/),
              (v54/*:: as any*/),
              (v55/*:: as any*/),
              (v56/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v57/*:: as any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeaturedImageType",
                        "kind": "LinkedField",
                        "name": "featuredImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageResourceType",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalUrl",
                                "storageKey": null
                              },
                              (v57/*:: as any*/),
                              (v18/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ContentResourceInterface",
                    "abstractKey": "__isContentResourceInterface"
                  }
                ],
                "type": "ResolvedResourceInterface",
                "abstractKey": "__isResolvedResourceInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RobotsType",
                    "kind": "LinkedField",
                    "name": "robots",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "index",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "follow",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canonicalUrlOverride",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CampaignResourceType",
                    "kind": "LinkedField",
                    "name": "primaryCampaign",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "advertiserName",
                        "storageKey": null
                      },
                      (v20/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShareableDataType",
                    "kind": "LinkedField",
                    "name": "social",
                    "plural": false,
                    "selections": [
                      (v40/*:: as any*/),
                      (v39/*:: as any*/),
                      (v62/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PromoDataType",
                    "kind": "LinkedField",
                    "name": "promo",
                    "plural": false,
                    "selections": [
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ledeMedia",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageResourceType",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": [
                              (v20/*:: as any*/),
                              (v58/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ThumbnailMapType",
                                "kind": "LinkedField",
                                "name": "thumbnails",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ThumbnailType",
                                    "kind": "LinkedField",
                                    "name": "social",
                                    "plural": false,
                                    "selections": [
                                      (v59/*:: as any*/),
                                      (v60/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LedeMediaImageType",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedImageType",
                    "kind": "LinkedField",
                    "name": "featuredImage",
                    "plural": false,
                    "selections": (v63/*:: as any*/),
                    "storageKey": null
                  },
                  (v57/*:: as any*/),
                  (v45/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasAffiliateLinks",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wordCount",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PackageResourceType",
                        "kind": "LinkedField",
                        "name": "package",
                        "plural": false,
                        "selections": (v64/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v65/*:: as any*/),
                        "concreteType": "FeedContentStreamsConnection",
                        "kind": "LinkedField",
                        "name": "streams",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StreamResourceType",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v64/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": "streams(first:100)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InternalSuperCatResourceType",
                        "kind": "LinkedField",
                        "name": "internalSuperCats",
                        "plural": true,
                        "selections": (v38/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuperCatResourceType",
                        "kind": "LinkedField",
                        "name": "superCats",
                        "plural": true,
                        "selections": (v38/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryResourceType",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryResourceType",
                        "kind": "LinkedField",
                        "name": "primaryCategory",
                        "plural": false,
                        "selections": [
                          (v35/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CategoryResourceType",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                              (v35/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v66/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "blocks",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductBlockProductType",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": (v14/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ProductBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LegacyProductBlockProductType",
                                "kind": "LinkedField",
                                "name": "legacyProduct",
                                "plural": false,
                                "selections": (v14/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "LegacyProductBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductBlockProductType",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": (v14/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ProductsTableBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LegacyProductBlockProductType",
                                "kind": "LinkedField",
                                "name": "legacyProducts",
                                "plural": true,
                                "selections": (v14/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "LegacyProductsTableBlockType",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedContentResourceInterfaceVideoGamesConnection",
                        "kind": "LinkedField",
                        "name": "games",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VideoGameResourceType",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": (v22/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "excludedFromHomepage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v65/*:: as any*/),
                        "concreteType": "FeedContentResourceInterfacePackagesConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PackageResourceType",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v56/*:: as any*/),
                              (v18/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "packages(first:100)"
                      },
                      (v67/*:: as any*/)
                    ],
                    "type": "FeedContentResourceInterface",
                    "abstractKey": "__isFeedContentResourceInterface"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v68/*:: as any*/)
                    ],
                    "type": "StreamResourceType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "quickAttachment",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v63/*:: as any*/),
                            "type": "CoreImageBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VolumeVideoResourceType",
                                "kind": "LinkedField",
                                "name": "video",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ImageResourceType",
                                    "kind": "LinkedField",
                                    "name": "poster",
                                    "plural": false,
                                    "selections": (v61/*:: as any*/),
                                    "storageKey": null
                                  },
                                  (v18/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "VideoBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v69/*:: as any*/),
                            "type": "ImageSliderBlockType",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v69/*:: as any*/),
                            "type": "CoreGalleryBlockType",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "QuickPostResourceType",
                    "abstractKey": null
                  },
                  (v67/*:: as any*/)
                ],
                "type": "ContentResourceInterface",
                "abstractKey": "__isContentResourceInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v68/*:: as any*/),
                  {
                    "alias": "streamPosts",
                    "args": (v65/*:: as any*/),
                    "concreteType": "ArchiveFeedContentConnection",
                    "kind": "LinkedField",
                    "name": "posts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isFeedContentResourceInterface"
                          },
                          (v20/*:: as any*/),
                          (v41/*:: as any*/),
                          (v42/*:: as any*/),
                          (v43/*:: as any*/),
                          (v32/*:: as any*/),
                          (v36/*:: as any*/),
                          (v44/*:: as any*/),
                          (v46/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CategoryResourceType",
                            "kind": "LinkedField",
                            "name": "primaryCategory",
                            "plural": false,
                            "selections": (v22/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CategoryResourceType",
                            "kind": "LinkedField",
                            "name": "categories",
                            "plural": true,
                            "selections": (v47/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoreParagraphBlockType",
                                "kind": "LinkedField",
                                "name": "excerpt",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RichTextType",
                                    "kind": "LinkedField",
                                    "name": "paragraphContents",
                                    "plural": true,
                                    "selections": (v31/*:: as any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PostResourceType",
                            "abstractKey": null
                          },
                          (v70/*:: as any*/),
                          (v52/*:: as any*/),
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "posts(first:100)"
                  }
                ],
                "type": "StreamResourceType",
                "abstractKey": null
              },
              (v70/*:: as any*/)
            ],
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "loudoun",
        "args": (v15/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v71/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "utah",
        "args": (v16/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v71/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "arizona",
        "args": (v17/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v71/*:: as any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e5c1debce25f6a5681a8faa6f5393318",
    "metadata": {},
    "name": "DataCentersHubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "67ac9a135ad8b0710d577a19c7b39e1f";

export default node;
